export { default, getStaticProps } from "app/seo/modes-de-livraison/page";
